/*
 * Introduction Quiz (myeverwell) — step navigation, required-consent gate, and
 * best-effort cart-attribute staging.
 *
 * The quiz stages the buyer's answers as native Shopify cart attributes (myew_*)
 * via /cart/update.js, then sends them to the continue URL. It never calls the
 * AWS backend — the data reaches it through the orders/paid webhook.
 *
 * Reliability: a /cart/update.js failure NEVER blocks checkout. We retry once and
 * then proceed regardless; missing data is recovered by the dashboard quiz.
 */
(function () {
  'use strict';

  var root = document.getElementById('IntroQuiz');
  if (!root) return;

  var form = document.getElementById('IntroQuizForm');
  var steps = Array.prototype.slice.call(form.querySelectorAll('.intro-quiz__step'));
  var backBtn = document.getElementById('IntroQuizBack');
  var nextBtn = document.getElementById('IntroQuizNext');
  var submitBtn = document.getElementById('IntroQuizSubmit');
  var consent = document.getElementById('IntroQuizConsent');
  var errorEl = document.getElementById('IntroQuizError');
  var progressBar = document.getElementById('IntroQuizProgressBar');
  var progressLabel = document.getElementById('IntroQuizProgressLabel');
  var scriptEl = document.querySelector('script[src*="introduction-quiz.js"]');

  var continueUrl = root.getAttribute('data-continue-url') || '/';
  var continueUrlMale = root.getAttribute('data-continue-url-male') || '';
  var continueUrlFemale = root.getAttribute('data-continue-url-female') || '';
  var consentVersion =
    (scriptEl && scriptEl.getAttribute('data-consent-version')) || 'v1';

  var SEX_MAP = { Femme: 'Female', Homme: 'Male' };
  var current = 0;

  function selectedCanonicalSex() {
    var el = form.querySelector('input[name="birth_sex"]:checked');
    return el ? SEX_MAP[el.value] || '' : '';
  }

  // Route to the kit that matches the buyer's birth sex; fall back to the
  // generic continue URL when a sex-specific URL isn't configured.
  function destinationUrl() {
    var sex = selectedCanonicalSex();
    if (sex === 'Male' && continueUrlMale) return continueUrlMale;
    if (sex === 'Female' && continueUrlFemale) return continueUrlFemale;
    return continueUrl;
  }

  function showError(message) {
    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      return;
    }
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function render() {
    steps.forEach(function (step, index) {
      step.hidden = index !== current;
    });
    var isLast = current === steps.length - 1;
    nextBtn.hidden = isLast;
    submitBtn.hidden = !isLast;
    backBtn.hidden = current === 0;
    submitBtn.disabled = isLast ? !consent.checked : true;

    var pct = Math.round(((current + 1) / steps.length) * 100);
    progressBar.style.width = pct + '%';
    progressLabel.textContent = pct + '%';
    showError('');
  }

  function validateStep() {
    var step = steps[current];
    var stepNumber = step.getAttribute('data-step');

    if (stepNumber === '1') {
      var dob = form.date_of_birth.value;
      if (!dob) {
        showError('Veuillez indiquer votre date de naissance.');
        return false;
      }
    } else if (stepNumber === '2') {
      if (!form.querySelector('input[name="birth_sex"]:checked')) {
        showError('Veuillez sélectionner une réponse.');
        return false;
      }
    }
    // Step 3 (goals) is optional; step 4 is gated by the consent checkbox.
    return true;
  }

  nextBtn.addEventListener('click', function () {
    if (!validateStep()) return;
    if (current < steps.length - 1) {
      current += 1;
      render();
    }
  });

  backBtn.addEventListener('click', function () {
    if (current > 0) {
      current -= 1;
      render();
    }
  });

  consent.addEventListener('change', function () {
    submitBtn.disabled = !consent.checked;
  });

  function collectAttributes() {
    var goals = Array.prototype.slice
      .call(form.querySelectorAll('input[name="wellness_goals"]:checked'))
      .map(function (el) {
        return el.value;
      });
    return {
      myew_dob: form.date_of_birth.value || '',
      myew_birth_sex: selectedCanonicalSex(),
      myew_goals: JSON.stringify(goals),
      myew_consent: 'accepted',
      myew_consent_version: consentVersion,
      myew_consent_ts: new Date().toISOString()
    };
  }

  function stageAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_update_failed');
      return response.json();
    });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!consent.checked) {
      submitBtn.disabled = true;
      return;
    }
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');

    var attributes = collectAttributes();
    var destination = destinationUrl();

    // Best-effort: try to stage, retry once, then proceed to checkout regardless
    // so a transient failure never loses the sale.
    stageAttributes(attributes)
      .catch(function () {
        return stageAttributes(attributes);
      })
      .catch(function () {
        /* swallow — the dashboard quiz is the recovery path */
      })
      .then(function () {
        window.location.assign(destination);
      });
  });

  render();
})();
